export default {
    action: {
        addNew: '新增',
        addToQuote: '添加到报价单',
        ahsUpload: '快递附加费上传',
        ahsTempDownload: '快递附加费模板',
        booking: '生成订单',
        confirm: '确认',
        cancel: '取消',
        clpInfoTempDL: '装箱单信息模板下载',
        createQuote: '生成报价单',
        deleteConfirm: '删除后不可恢复，确认删除?',
        delete: '删除',
        expUPSUpload: 'UPS基础价卡上传',
        expUSPSUpload: '美国邮政基础价卡上传',
        expFDXUpload: 'FDX基础价卡上传',
        edit: '编辑',
        fbaComparison: 'FBA与第三方配送价格对比',
        fbaCalculator: 'FBA费用估算',
        fdxBaseTempDownload: 'FDX基础价卡模板',
        fileSelect: '选择文件',
        getQuote: '获取报价',
        getPDF: 'PDF',
        instruction: '操作说明',
        imex: '进/出口',
        next: '下一步',
        operation: '操作',
        oceanFreightRatesUpload:'海运价卡上传',
        oceanFreightTempDownload:'海运价卡模板下载',
        previous: '上一步',
        refresh: '刷新',
        review: '查看',
        resultDownload: '测算结果下载',
        showDetails: '报价明细',
        submitUpload: '提交上传',
        templateDownload: '快递账单模板下载',
        uomSys: '计量体系',
        uspsPeakFeeUpload: '美国邮政旺季附加费上传',
        uspsPeakFeeDownload: '美国邮政旺季附加费模板',
        upsBaseTempDownload: 'UPS基础价卡模板',
        uspsBaseTempDownload: '美国邮政基础价卡模板',
        vue2: '海运上传Vue2',
        vue3: '海运基础价卡上传',
        warehouseRatesUpload:'仓库价卡上传',
        warehouseTempDownload: '仓库价卡模板下载'
    },
    agentFee: {
        title: '代理服务',
        id: 'Id',
        vendor: '服务商',
        srvPort: '服务港',
        ctnrType: '柜型',
        currency: '计价币种',
        rates: '报价',
        legcode: '节点代码',
        chargeType: '费用类型',
        chargeDescription: '费用内容',
        uom: '计价单位',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
        rctag: '价卡标签',
    },
    allCHB: {
        title: '报关服务',
        id: 'Id',
        vendor: '服务商',
        srvPort: '服务港',
        legcode: '节点代码',
        chargeType: '费用类型',
        chargeDescription: '费用内容',
        rates: '报价',
        uom: '计价单位',
        currency: '计价币种',
        adjust: '调整',
        notes: '注释',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    basicInfo: {
        ctnrCounts:'集装箱数'
    },
    bookContract: {
        title: '合同订单',
        id: 'Id',
        trackNumber: '追踪号',
        l3Owner: '合同持有者',
        clientName: '客户',
        broker: '中介',
        payTerm: '付款周期',
        quoteTotal: '合同总金额',
        targetMargin: '预计利润',
        marginpct: '预计利润率',
        pdf: '合同PDF',
        oceanFreight: '海运',
        origAgent: '始发地代理',
        origChb: '始发地清关服务',
        origDray: '始发地托卡',
        origWarehouse: '始发地仓库',
        origTruck: '始发地卡派',
        origExpress: '始发地快递',
        destAgent: '目的地代理',
        destChb: '目的地清关服务',
        destDray: '目的地托卡',
        destWarehouse: '目的地仓库',
        destTruck: '目的地卡派',
        destExpress: '目的地快递',
        origAir: '始发地空运',
        destAir: '目的地空运',
        origRail: '始发地铁路',
        destRail: '目的地铁路',
        status: 'Status',
        basicinfo: '基本信息',
        documents: '物流文件材料',
        shipinfo: '航运信息',
        paymentinfo: '付款信息',
        notes: 'Notes',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    chargecode: {
        title: '费用条目编辑',
        chainLocation: '节点位置',
        leg: '节点',
        chargeType: '费用类型',
        uom: '计价单位',
        chargeDescription: '费用内容',
        legcode: '节点代码',
        legseq: '节点序列数',
        apcode: '财务代码',
        notes: '注释'
    },
    chart:{
        unit:'$',
        rates: '费率',
        ofRatesTitle:'宁波-洛杉矶40HQ集装箱各船公司海运费用',
        fbaCostTitle: 'FBA 费用分解饼图, 包装尺寸30x20x10(inch), 10(lb), 15天仓储',
        expCostTitle: '快递价格比较： 包装尺寸30x20x10(inch), 10(lb), Zone 4',
        bestRates: 'Best Rates',
        secondBest: 'Second Best',
        thirdBest: 'Third Best',
        fourthBest:'Fourth Best'
    },
    chassis:{
        title: '托车支架',
        id: 'ID',
        chassisId: '支架 ID',
        status: '状态',
        type: '支架类型',
        dailyCost: '每日使用费 USD',
        expDate: '到期日',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
        inclExcl: 'Incl or Excl (1/0)',
    },
    client: {
        title: '客户',
        id: 'Id',
        shortName: '客户简称',
        legalName: '客户正式名称',
        type: '客户类别',
        status: '状态',
        einortaxid: '税务号',
        w9link: 'W9 Link',
        dunScore: 'Dun Score',
        creditLimit: '授信额度',
        contractStatus: '合同状态',
        contactName: '联系人',
        contactTitle: '联系人职位',
        email: 'Email',
        phone: '电话',
        country: '国家',
        region: '地域',
        address: '地址',
        otruckpterm: '头程卡车支付周期',
        ochbpterm: '头程清关支付周期',
        owhspterm: '头程仓库支付周期',
        odraypterm: '头程托卡支付周期',
        agentpterm: '中介代理支付周期',
        nvopterm: '无船承运支付周期',
        p2ppterm: 'P2P支付周期',
        dchbpterm: '尾程清关支付周期',
        ddraypterm: '尾程托卡支付周期',
        dwhspterm: '尾程仓库支付周期',
        dtruckpterm: '尾程卡车支付周期',
        expresspterm: '快递支付周期',
        otherspterm: '其他无法支付周期',
        sales: '销售',
        csr: '客服',
        oop: '头程运营',
        dop: '尾程运营',
        csopemail: '运营 Email',
        linkedEntities: '关联实体',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    packingSummary: {
        sku: 'SKU个数',
        cartons: '包装箱数',
        pallets: '托盘数'
    },
    drayage: {
        title: '港口拖车',
        id: 'Id',
        vendor: '服务商',
        validStart: '有效期起始日',
        validEnd: '有效期终止日',
        fromArea: '起始地',
        toArea: '到达地',
        desType: '目的地类别',
        dropType: '卸柜方式',
        drayage: '车费',
        bobtail: 'Bobtail',
        total: '费用总和',
        remark: '备注',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    draySrvFee: {
        title: '托卡杂费',
        id: 'Id',
        legcode: '节点代码',
        chargeType: '费用类型',
        chargeDescription: '费用内容',
        rates: '报价',
        uom: '计价单位',
        adjust: '调整',
        notes: '注释',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expressFDX: {
        title: '联邦快递-Fedex',
        id: 'Id',
        weight: '重量',
        zone2: '距离2',
        zone3: '距离3',
        zone4: '距离4',
        zone5: '距离5',
        zone6: '距离6',
        zone7: '距离7',
        zone8: '距离8',
        toAk: 'To AK',
        toHi: 'To HI',
        vendor: '服务商',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expAHS: {
        title: '快递附加费',
        id: 'Id',
        chargeDescription: 'Charge Description',
        zone2: '距离2',
        zone3: '距离3',
        zone4: '距离4',
        zone5: '距离5',
        zone6: '距离6',
        zone7: '距离7',
        zone8: '距离8',
        toAk: 'To AK',
        toHi: 'To HI',
        vendor: 'Vendor',
        courier: 'Courier',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expListUSA:{
        title: '快递价卡总表',
        id: 'Id',
        lspname: '物流供应商',
        courier: '快递公司',
        product: '快递产品',
        srvstate: '服务州',
        rctag: '价卡标签',
        validStart: '有效期起始',
        validEnd: '有效期结束',
        notes: '备注',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expressCost: {
        title: '快递费用',
        id: 'Id',
        refid: '识别 ID',
        vendor: '服务商',
        courier: '快递公司',
        fromZip: '发货地址邮编',
        toZip: '收货地址邮编',
        zone: '距离',
        resiAddr: '是否居民地址',
        peak: '是否旺季',
        pkgs: '包裹数量',
        length: '长',
        width: '宽',
        height: '高',
        weight: '重量',
        girth: '周长指标',
        billWeight: '计费重量',
        baseRate: '基础费用',
        ahsWeight: '超重费',
        ahsLength: '超长费',
        ahsWidth: '超宽费',
        ahsGirth: '周长超标费',
        ahsPackage: '包装超标费',
        lpsCom: '商业大件',
        lpsRes: '居民大件',
        uos: '超级大件',
        resSurcharge: '居民地址附加费',
        fsc: '燃油附加费',
        peakTotalsc: '旺季附加费总和',
        notes: '备注',
        vendorsrvfee: '服务商收费',
        dasRes: '偏远居民地址',
        dasCom: '偏远商业地址',
        dasExtRes: '超偏远居民地址',
        dasExtCom: '超偏远商业地址',
        total: '总计',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expressUPS: {
        title: 'UPS快递',
        id: 'Id',
        weight: '重量',
        zone2: '距离2',
        zone3: '距离3',
        zone4: '距离4',
        zone5: '距离5',
        zone6: '距离6',
        zone7: '距离7',
        zone8: '距离8',
        zone44: '距离44',
        zone45: '距离45',
        zone46: '距离46',
        vendor: '服务商',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expOtherFee: {
        title: '快递杂费',
        id: 'Id',
        pkfGround: '旺季附加费',
        pkfAhs: '旺季AHS附加费',
        pkfLps: '旺季LPS附加费',
        pkfUos: '旺季UOS附加费',
        pkfResideli: '旺季住宅投递附加费',
        resideli: '住宅投递附加费',
        fsc: '燃油附加费',
        dimIndex: '泡重系数',
        lspHdlfee: 'LSP操作费',
        dasCom: '偏远商业地址投递费',
        dasRes: '偏远住宅地址投递费',
        dasexdcom: '超偏远商业地址投递费',
        dasexdres: '超偏远住宅地址投递费',
        dasAk: 'AK偏远商业地址投递费',
        dasHi: 'HI偏远商业地址投递费',
        uos: '超级大件',
        vendor: '服务商',
        courier: '快递公司',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    expUSPS: {
        title: '美国邮政-USPS',
        id: 'Id',
        weight: '重量',
        unit: '单位',
        zone1: '距离1',
        zone2: '距离2',
        zone3: '距离3',
        zone4: '距离4',
        zone5: '距离5',
        zone6: '距离6',
        zone7: '距离7',
        zone8: '距离8',
        zone9: '距离9',
        nc6: '远距6',
        nc7: '远距7',
        nc8: '远距8',
        vendor: '服务商',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    eTower:{
        title: 'eTower',
        bookedServices:'获取开通的服务',
        createOrders: '创建订单',
        printLabel: '打印面单',
        quoteInquiry: '运费试算',
        serviceCode: '服务代码',
        serviceName: '服务名称',
        nativeName: '原生名称',
        serviceProvider: '服务提供商',
        serviceProviderCode: '服务提供商代码',
        serviceDescription: '服务详情',
        tracking:'订单跟踪',
    },
    fBACost: {
        title: 'FBA费用',
        id: 'Id',
        refid: '识别ID',
        sku: 'SKU',
        lowprice: '是否低价品',
        apparel: '是否服装',
        peak: '是否旺季',
        pkgs: '包裹数',
        length: '长',
        width: '宽',
        height: '高',
        weight: '重量',
        billWeight: '计费重量',
        sizetier: '计费级别',
        baseRate: '基础费用',
        ibplacefee: '入仓分仓费',
        stodays: '仓储天数',
        stocost: '仓储费',
        peakTotalsc: '旺季附加费总额',
        otherfee: '其他费用',
        total: '总额',
        notes: '备注',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    globalPort: {
        title: '全球港口',
        id: 'Id',
        portCode: '港口标准码',
        city: '城市',
        state: '州/省',
        country: '国家',
        swRegion: '地区',
        seaport: '海港',
        dryport: '陆地港',
        barge: 'Barge',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    instruction: {
        upsRateCardsUpload:'1.填写服务商,适用地,生效起止时间以及各项杂费等-->'+
            '2.点击“UPS基础价卡模板”下载价卡模板-->' +
            '3.点击“快递附加费模板”下载-->' +
            '4.完成两个模板的填充并按照按键指引上传-->' +
            '5.此时下方“提交上传”的按键会生效-->' +
            '6.点击“提交上传”-->' +
            '7.上传成功后会跳转到全部快递价卡总表页面'
        ,
        fdxRateCardsUpload:'1.填写服务商,适用地,生效起止时间以及各项杂费等-->'+
            '2.点击“FDX基础价卡模板”下载价卡模板-->' +
            '3.点击“快递附加费模板”下载-->' +
            '4.完成两个模板的填充并按照按键指引上传-->' +
            '5.此时下方“提交上传”的按键会生效-->' +
            '6.点击“提交上传”-->' +
            '7.上传成功后会跳转到全部快递价卡总表页面'
        ,
        uspsRateCardsUpload:'1.填写服务商,适用地,生效起止时间以及各项杂费等-->'+
            '2.点击“美国邮政基础价卡模板”下载价卡模板-->' +
            '3.点击“美国邮政旺季附加费模板”下载-->' +
            '4.完成两个模板的填充并按照按键指引上传-->' +
            '5.此时下方“提交上传”的按键会生效-->' +
            '6.点击“提交上传”-->' +
            '7.上传成功后会跳转到全部快递价卡总表页面'
        ,
    },
    issuedquotes: {
        title: '已发出报价',
        id: 'Id',
        pdf: '报价PDF',
        l3Owner: 'L3持有者',
        clientName: '客户',
        payTerm: '支付条款',
        broker: '中介',
        validby: '有效期',
        fak: 'FAK',
        hazdg: '是否危险品',
        srvCategory: '服务类别',
        usdExchrate: '美元汇率',
        createBy: 'Create By',
        createTime: 'Create Time',
        updateBy: 'Update By',
        updateTime: 'Update Time',
        quoteTotal: '报价总金额',
        targetMargin: '利润预期',
        marginpct: '预期利润率',
        oceanFreight: '海运',
        oAgent: '出发地代理',
        oChb: '出口清关',
        oDray: '出发地托卡',
        oWarehouse: '出发地仓库',
        oTruck: '出发地卡派',
        oExpress: '出发地快递',
        dAgent: '目的地代理',
        dChb: '进口清关',
        dDray: '目的地托卡',
        dWarehouse: '目的地仓库',
        dTruck: '目的地卡派',
        dExpress: '目的地快递',
        oAir: '起始地空运',
        dAir: '目的地空运',
        oRail: '起始地铁路',
        dRail: '目的地铁路',
        status: '状态',
        notes: '备注',
    },
    oceanFreight: {
        title: '海运',
        id: 'Id',
        vendor: '货代',
        pol: '始发港',
        destination: '目的地',
        validStart: '有效期起始日',
        validEnd: '有效期终止日',
        carrier: '航运公司',
        pod: '目的港',
        ipi: '是否联运',
        ctnrType: '柜型',
        rates: '运价',
    },
    oTHC: {
        title: '港口附加费',
        id: 'Id',
        srvPort: '服务港口',
        carrier: '航运公司',
        ctnrType: '柜型',
        rates: '报价',
        currency: '计价币种',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    originSrvFee: {
        title: '头程服务费',
        id: 'Id',
        vendor: '服务商',
        pol: '始发港',
        ctnrType: '柜型',
        currency: '计价币种',
        rates: '报价',
        legcode: '节点代码',
        chargeType: '费用类型',
        chargeDescription: '费用内容',
        uom: '计价单位',
        rctag: '价卡标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    legCode: {
        title: '节点代码',
        id: 'Id',
        legseq: '节点序列数',
        legcode: '节点代码',
        chainLocation: '节点位置',
        role: '服务',
        legtype: '节点类型',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    login: {
        welcomeText: '系统概述: 已完成海运公司，货代，海外仓，港口拖车，海关报关，卡车, 快递的综合报价，报价单维护以及基础信息维护',
        homepage: '首页',
        onlineERP: '跨境服务商报价系统',
        username: '用户名',
        password: '密码',
        loginSys: '登录系统',
        loginByUsername: '用户名密码登录',
        logout: '登出',
        changePSD: '修改密码',
        sendCode: '获取验证码',
        qrcode: '二维码登陆'
    },
    navBar: {
        adminPanel: '控台管理',
        administrative: '在线办公',
        approval: '审批任务',
        billcheck: '对账',
        comboQuotes: '综合报价',
        createNewRateCard:'新建价卡',
        dashboard: '首页',
        department: '部门管理',
        disciplinaryFines: '违纪罚款',
        expbillcheck:'快递对账',
        employ: '组织管理',
        express: '快递',
        externalAPI: '外部 API',
        e2e: 'E2E',
        issuedquotes: '已发出报价',
        lang: '国际化',
        leaveRequest: '员工请假',
        master: '基础数据',
        meetings: '会议管理',
        meetingRoom: '会议室',
        multiSize:'多规格',
        myTicket: '我的车票',
        navigate: '导航',
        onlineMeetings: '线上会议',
        offlineMeetings: '线下会议',
        oceanFreight: '海运',
        passenger: '乘车人管理',
        quotes: '报价',
        rates: '费率',
        rcUpload: '价卡上传',
        ratebyuom:'按计量单位报价',
        ratecards: '价卡管理',
        ratesComparison: '价卡对比图',
        reimburse: '报销管理',
        role: '角色管理',
        seatStats: '座位销售图',
        singleSize: '单一规格',
        test: '测试',
        ticketsAvailable: '余票查询',
        user: '用户管理',
        welcome: '欢迎',
    },
    paymentFactor: {
        title: '支付条件参数',
        id: 'Id',
        clientTier: '客户等级',
        paymentTerm: '付款周期',
        lane: '线路',
        minMargin: '最小利润',
        markup: '例如率',
        maxMargin: '最大利润',
        roundFactor: '取整系数',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    placeholder: {
        timeSelect: '请选择时间',
        dateSelect: '请选择日期'
    },
    passenger: {
        passenger: '乘车人',
        passengerName: '乘车人姓名',
        passengerId: '乘车人身份证',
        passengerType: '乘车人类型'
    },
    quotes: {
        title: '报价',
        id: 'Id',
        vendor: '服务商',
        legcode: '节点代码',
        chargeType: '费用类型',
        chargeDescription: '费用内容',
        rateType: '报价类型',
        rateDetail: '报价详情',
        uom: '计价单位',
        rates: '成本价',
        rateL4: '售价',
        apUnits: 'AP发生计数',
        apValue: 'AP发生额',
        arUnits: 'AR发生计数',
        arValue: 'AR发生额',
        apInv: 'AP发票号',
        arInv: 'AR发票号',
        apDisp: 'AP争议单号',
        arDisp: 'AR争议单号',
        legseq: '节点序列数',
        currency: '计价币种',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    rateByUOM:{
        pol:'发货港',
        peak:'是否旺季',
        resiAddr:'目的地是否为民宅',
        uomSystem:'计量体系',
        length: '长',
        width: '宽',
        height: '高',
        weight: '重量',
        packages: '包装数',
        storageDays: '仓储天数',
        oceanFreight: '海运',
        agent: '代理',
        chb: '海关清关',
        dray: '港口拖车',
        warehouse: '海外仓',
        truck: '卡车',
        express: '快递',
        total: '总额',
        perKg: '每公斤费率',
        perLb: '每磅费率'
    },
    shipInfo: {
        title: 'ShipInfo',
        id: 'ID',
        trackNumber: '跟踪号',
        clientName: '客户名',
        mbl: 'MBL',
        ctnrId: '集装箱ID',
        pol: 'POL',
        pod: 'POD',
        podRegion: 'POD所属区域',
        ctnrType: '集装箱柜型',
        ctnrKg: '集装箱重量（KG）',
        goodsName: '货物名称',
        danger: '是否危险品',
        shipStatus: '航运状态',
        destSite: '目的地',
        destCode: '目的地代码',
        destAddr: '目的地地址',
        erAddr: '空柜返还地址',
        carrier: '航运公司',
        firmsCode: '目的港码头代码',
        ddray: '目的地托卡运营商',
        etd: 'ETD',
        atd: 'ATD',
        eta: 'ETA',
        ata: 'ATA',
        discharge: '卸船日期',
        lfd: 'LFD',
        termpickupapp: '港口提柜预约时间',
        fullGateout: '满柜出港时间',
        dwhcrdd: '目的地仓库 CRDD',
        dwhArrival: '到达目的地仓库时间',
        dwhEmptynotify: '目的地仓库时间空柜通知时间',
        emptyReturnappt: '空柜返还预定时间',
        emptyReturn: '空柜返还时间',
        chassisId: '车架ID',
        paydue: '付款日期',
        paystatus: '付款状态',
        desType: '目的地类别',
        dropType: '托卡卸柜方式',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    toast: {
        loginFailed: '未登录或登录超时',
        deleteSuccess: '删除成功!',
        loginSuccess: '登录成功!',
        saveSuccess: '保存成功!',
        sendCodeSuccess: '发送验证码成功!',
        switchLangSuccess: '切换语言成功!'
    },
    truckUSFTL: {
        title: '卡派',
        id: 'Id',
        vendor: '服务商',
        desType: '目的地类别',
        fromArea: '出发地',
        legcode: '节点代码',
        total: '总计',
        toArea: '到达地',
        rates: '报价',
        city: '城市',
        notes: '备注',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    vendor: {
        title: '供应商',
        id: 'Id',
        shortName: '简称',
        legalName: '法定名',
        type: '类别',
        status: '状态',
        einortaxid: '税务识别号',
        w9link: 'W9link',
        dunScore: 'DunScore',
        creditLimit: '信用额度',
        contractStatus: '合同状态',
        contactName: '联系人',
        contactTitle: '联系人职位',
        email: 'Email',
        phone: '电话',
        country: '国家',
        region: '地域',
        address: '地址',
        otruck: '头程卡车',
        ochb: '头程清关',
        owhs: '头程仓库',
        odray: '头程托卡',
        agent: '中介代理',
        nvo: '无船承运',
        p2p: 'P2P',
        dchb: '尾程清关',
        ddray: '尾程托卡',
        dwhs: '尾程仓库',
        dtruck: '尾程卡派',
        express: '快递',
        others: '其他',
        vm: '供应商管理',
        op: '运营',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    vin:{
        title: '用车记录',
        id: '系统ID',
        vinId: '车头号',
        status: '车头状态',
        driver: '司机',
        logDate: '记录日期',
        startHour: '开始时间',
        endHour: '结束时间',
        odoStart: '开始里程',
        odoEnd: '结束里程',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '更新人',
        updateTime: '更新时间',
        inclExcl: '包括/不包括',
    },
    uSPSOtherFee:{
        title: '美国邮政附加费',
        id: 'Id',
        overlength: '超长附加费',
        oversize: '超规格附加费',
        overlengthlimit: '特别超长附加费',
        overvolume: '体积超标附加费',
        dimIndex: '泡重系数',
        lspHdlfee: 'LSP操作费',
        vendor: '服务商',
        rctag: '标签',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    uSPSPeakFee:{
        title: '美国邮政旺季费',
        id: 'Id',
        weight: '重量',
        unit: '单位',
        zone1: '距离1',
        zone2: '距离2',
        zone3: '距离3',
        zone4: '距离4',
        zone5: '距离5',
        zone6: '距离6',
        zone7: '距离7',
        zone8: '距离8',
        zone9: '距离9',
        nc6: '远距6',
        nc7: '远距7',
        nc8: '远距8',
        vendor: '服务商',
        rctag: '标签',
        validStart: '有效期起始日',
        validEnd: '有效期终止日',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    wareHouse: {
        title: '仓库',
        id: 'Id',
        vendor: '服务商',
        srvPort: '服务港口',
        chargeType: '费用类型',
        chargeDescription: '费用内容',
        rateType: '报价类别',
        ctnrType: '柜型',
        uom: '计价单位',
        rates: '报价',
        tieredJson: '分级报价',
        currency: '计价币种',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '编辑人',
        updateTime: '编辑时间',
    },
    wHS:{
        title: '仓库',
        id: '系统ID',
        whsId: '仓库ID',
        whsName: '仓库名称',
        clientId: '所属客户ID',
        status: '仓库状态',
        pic: '负责人',
        phone: '负责人电话',
        email: '负责人邮箱',
        address1: '街道地址',
        address2: '街道地址 (续)',
        city: '城市',
        state: '州省',
        zip: '邮编',
        country: '国家',
        workday: '工作日',
        startTime: '上班时间',
        closeTime: '下班时间',
        gated: '门栏护卫',
        dlAppt: '送货预约',
        drop: '接受落柜',
        live: '当场卸柜',
        comment: '备注',
        createBy: '创建人',
        createTime: '创建时间',
        updateBy: '更新人',
        updateTime: '更新时间',
        inclExcl: '计入/不计',
    }
}
